// extracted by mini-css-extract-plugin
export default {"container":"RestrictedSubmissionsInput_container__VgHZU","switch":"RestrictedSubmissionsInput_switch__QoW4C","rules":"RestrictedSubmissionsInput_rules__Rms0M"};